<template>
  <div class="self-doubts">
    <div class="g-box">
      <div class="title kf-animate kf-animate-fade">
        {{ dataInfo.tips }} <span class="zh">{{ dataInfo.name }}</span>
      </div>
      <div class="content">
        <div class="con-le">
          <div class="item" v-for="item in dataList" :key="item.id">
            {{ item.title }}
          </div>
          <div class="more">
            <div class="more-in" @click="toSeek">
              <a
                class="txt"
                href="javascript:void(0)"
                onclick="openJesongChatByGroup(13659,36257);return false;"
                >立即咨询</a
              >
              <span class="line"></span>
              <div class="orcal"></div>
            </div>
          </div>
        </div>
        <div class="con-line"></div>
        <div class="con-ri">
          <div class="tt">23年自考专升本已开始</div>
          <div class="tt">
            预缴1000元，即可获得<span class="col">2000</span>元膨胀金
          </div>
          <div class="input">
            <input
              placeholder="请输入你的手机号"
              v-model="phone"
              class="ipt"
              type="text"
            />
          </div>
          <div class="more">
            <div class="more-in" @click="handleSubmit">
              <span class="txt">立即提交</span><span class="line"></span>
              <div class="orcal"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import { Message } from "element-ui";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      phone: "",
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
  },
  methods: {
    toSeek() {
      // window.open("https://www.baidu.com/");
      this.openJesongChatByGroup(13659, 36257);
      return false;
    },
    handleSubmit() {
      if (!this.phone) return Message("请先输入手机号");
      this.$api.ums.promote.backgroundMessage_messageForClient
        .post({ phone: this.phone })
        .then(() => {
          Message.success("提交成功，请耐心等待老师与您联系");
          this.phone = "";
        });
    }
  }
};
</script>

<style lang="less">
.self-doubts {
  padding-bottom: 70px;
  padding-top: 100px;
  box-sizing: border-box;
  .title {
    text-align: center;
    font-size: 72px;
    font-family: "en-tit";
    color: #000;
    line-height: 87px;
    text-transform: uppercase;
    .zh {
      padding-left: 20px;
      font-size: 48px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .content {
    padding-top: 50px;
    display: flex;
    align-items: center;
    .con-le {
      position: relative;
      width: 600px;
      height: 523px;
      // border: 1px dashed #c4c4c4;
      text-align: center;
      box-sizing: border-box;
      .item {
        margin-bottom: 30px;
        font-size: 28px;
        font-weight: 500;
        color: #666666;
        line-height: 40px;
      }
    }
    .con-line {
      margin: 0 80px;
      width: 1px;
      height: 613px;
      background-color: #c4c4c4;
    }
    .con-ri {
      position: relative;
      padding-top: 96px;
      width: 500px;
      height: 523px;
      // border: 1px dashed #c4c4c4;
      text-align: center;
      box-sizing: border-box;
      .tt {
        font-size: 28px;
        font-weight: 500;
        color: #666;
        line-height: 40px;
        .col {
          color: #ff7741;
        }
      }
      .ipt {
        margin-top: 70px;
        padding-left: 20px;
        width: 400px;
        height: 50px;
        background: #f7f8fc;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.14);
        border: none;
        border-radius: 6px;
      }
    }
    .more {
      position: absolute;
      bottom: -20px;
      left: 50%;
      margin-left: -85px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000;
      .more-in {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .txt {
        margin-right: 16px;
      }
      .line {
        margin-right: -35px;
        width: 50px;
        height: 1px;
        background-color: #2c6fff;
      }
      .orcal {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 10px solid #2c6fff;
      }
    }
  }
}
</style>
